<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <rect x="0" y="0" width="24" height="8" fill="#000000" />
    <rect x="0" y="8" width="24" height="8" fill="#DD0000" />
    <rect x="0" y="16" width="24" height="8" fill="#FFCE00" />
</svg>
